import React from "react";
import { useMutation } from "react-query";
import { reminderUser } from "./gateway";
import { useNavigate } from "react-router-dom";

export default function useReminderPass() {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: reminderUser,
    onSuccess: () => {
      navigate("/welcome/reminderCheckEmail");
    },
  });
}
